module.exports = __webpack_public_path__ + "img/mastercard.299baf42.svg";